import {
  OneviewReviewReviewActionChoices,
  ReviewAdviceActionEnum,
} from '../schema-types/globalTypes';
import {ReviewSubmissionFragment} from '../schema-types/ReviewSubmissionFragment';

/**
 * Determines the appropriate redirect path after review submission based on review action and user permissions
 */
export const getReviewSubmissionRedirect = ({
  reviewDetails,
  canUseReportPack,
}: {
  reviewDetails: Pick<
    ReviewSubmissionFragment,
    'account' | 'id' | 'reviewAction' | 'adviceAction'
  >;
  canUseReportPack: boolean;
}) => {
  const {account, id: reviewId, reviewAction, adviceAction} = reviewDetails;
  const accountId = account?.id;

  // Return to reviews page if accountId is not available
  if (!accountId) {
    return '/search'; // Fallback to search page if no account
  }

  // Return to reviews page if reviewId is not available
  if (!reviewId) {
    return `/account/${accountId}/reviews`;
  }

  // For declined or no response reviews, redirect based on report pack permissions
  if (
    reviewAction === OneviewReviewReviewActionChoices.DECLINED_BY_CLIENT ||
    reviewAction === OneviewReviewReviewActionChoices.NO_RESPONSE_FROM_CLIENT ||
    adviceAction === ReviewAdviceActionEnum.NO_ADVICE
  ) {
    if (canUseReportPack) {
      // Go to the report page
      return `/account/${accountId}/review-journey/${reviewId}/report`;
    }
    // Go back to the reviews page
    return `/account/${accountId}/reviews`;
  }

  // For other review actions, go to the summary page to show the submitted review
  return `/account/${accountId}/review-journey/${reviewId}`;
};
